import { useNavigate } from 'react-router-dom';
import { WalletCards } from 'lucide-react';
import PropTypes from 'prop-types';

import { useCreditSummary } from '@/feature/Billing/hooks/useBilling.js';
import { formatToman } from '@/feature/Billing/utils/billingFormatters.js';
import useSelectedTenant from '@/shared/hooks/useSelectedTenant.js';
import { cn } from '@/shared/utils/cn.js';

export default function CreditQuickAccess({ compact = false }) {
  const navigate = useNavigate();
  const { tenantId, hasTenant } = useSelectedTenant();
  const credit = useCreditSummary(tenantId);
  const creditData = credit.data?.data;

  return (
    <button
      type="button"
      onClick={() => navigate('/credit')}
      className={cn(
        'border-tertiary-20 hover:border-primary-40 hover:bg-primary-10 group flex cursor-pointer items-center rounded-xl border bg-white text-right shadow-sm transition-all dark:border-gray-700 dark:bg-gray-800 dark:hover:border-gray-600 dark:hover:bg-gray-700',
        compact ? 'h-10 w-10 justify-center p-0' : 'min-h-10 gap-2 px-3 py-1.5',
      )}
      aria-label="مشاهده و افزایش اعتبار"
      title="اعتبار و شارژ حساب"
    >
      <span className="bg-primary-10 text-primary-100 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg dark:bg-orange-500/15 dark:text-orange-400">
        <WalletCards size={17} />
      </span>
      {!compact && (
        <span className="hidden min-w-0 xl:block">
          <span className="text-tertiary-60 block text-[10px] dark:text-gray-400">
            اعتبار مرکز
          </span>
          <span className="text-tertiary-100 block max-w-32 truncate text-xs font-black dark:text-gray-100">
            {!hasTenant
              ? 'انتخاب مرکز'
              : credit.isLoading
                ? 'در حال دریافت...'
                : creditData
                  ? formatToman(creditData.available_irr)
                  : 'مشاهده اعتبار'}
          </span>
        </span>
      )}
    </button>
  );
}

CreditQuickAccess.propTypes = {
  compact: PropTypes.bool,
};
